import { useEsigningAuthenticationModes } from '../useEsigningAuthenticationModes';
import { useEsigningProviderMetadata } from '../useEsigningProviderMetadata';
export const useUnsupportedRecipientValues = () => {
    const { authenticationModes } = useEsigningAuthenticationModes();
    const { properties } = useEsigningProviderMetadata();
    const { nameFormat } = properties;
    const supportedAuthenticationModes = authenticationModes.map((mode) => mode.slug);
    // Check if the recipient has an authentication mode that is not supported by the provider
    const isAuthenticationModeUnsupported = (recipient) => {
        const { authenticationMode } = recipient;
        return authenticationMode !== undefined && !supportedAuthenticationModes.includes(authenticationMode);
    };
    // Check if the recipient has a name format that is not supported by the provider
    const isNameFormatUnsupported = (recipient) => {
        const { name, firstName, lastName } = recipient;
        if (nameFormat === 'fullName') {
            return !name;
        }
        return !firstName || !lastName;
    };
    return {
        isAuthenticationModeUnsupported,
        isNameFormatUnsupported,
    };
};
